import "react-app-polyfill/ie11";
import "core-js/stable";
import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import MainWebChat from "./components/MainWebchat";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";
import setCWACookies from "./util/setCWACookies";
import getCWACookies from "./util/getCWACookies";
import { createDirectLine } from "botframework-webchat";
import ErrorHandler from "./components/ErrorHandler";
import { getToken, getRefreshToken } from "./util/httprequest";
import styleSet from "./util/chatBotCustomStyleSet";
import { AppContext } from "./util/appContext";
import { setCookie, getCookie, eraseCookie } from './util/cookieActions';
import pmtHpsNonprodConfig from './configencrypted/pmt_hps_config.json';
import pmtHpsProdConfig from './configencrypted/pmt_hps_prod_config.json';
import spsEcommNonprodConfig from './configencrypted/sps_ecomm_config.json';
import spsEcommProdConfig from './configencrypted/sps_ecomm_prod_config.json';
import hbtChinaNonprodConfig from './configencrypted/hbt_china_config.json';
import hbtChinaProdConfig from './configencrypted/hbt_china_prod_config.json';
import hbtNonprodConfig from './configencrypted/hbt_config.json';
import hbtProdConfig from './configencrypted/hbt_prod_config.json';
import pmtUopNonprodConfig from './configencrypted/pmt_uop_config.json';
import pmtUopProdConfig from './configencrypted/pmt_uop_prod_config.json';
import hceTridiumNonprodConfig from './configencrypted/hce_tridium_config.json';
import hceTridiumProdConfig from './configencrypted/hce_tridium_prod_config.json';
import spsGdmNonprodConfig from './configencrypted/sps_gdm_config.json';
import spsGdmProdConfig from './configencrypted/sps_gdm_prod_config.json';
import spsTsNonprodConfig from './configencrypted/sps_ts_config.json';
import spsTsProdConfig from './configencrypted/sps_ts_prod_config.json';
import decryptText from './util/decrypt';
import StaticLabels from "./util/staticLabels.json";
import liveAgentStaticLabels from "./util/liveAgentStaticLabels.json";
import { fetchAndCacheAttachment } from "./components/AgentAttachmentCard";
import disableProactivity from "./util/disableProactivity";

//Main entry component for connecting to Bot.
export default () => {
  // let appInsights = null;
  const [isMaximised, setMaximizeflag] = useState(false);
  const [directLine, setDirectLine] = useState();
  const [store, setStore] = useState();
  const [isLiveAgent, setLiveAgent] = useState(false);
  const [showSpinner, setSpinner] = useState(true);
  const [isOpenModal, showModal] = useState(false);
  const [isSurveyOpen, showSurvey] = useState(false);
  const [errorOccured, showErrorPage] = useState({
    isErrorOccured: false,
    message: ""
  });
  const headerRef = useRef();
  const [userLanguage, setUserLanguage] = useState("");
  const [appInsights, setAppInsights] = useState(null);
  const [isSurveySubmitted, setSurveyFlag] = useState(false);
  const [headerIconsDisplay, setHeaderIconsDisplay] = useState(true);
  const [showTimerBox, setShowTimerBox] = useState(false);
  const [callbackFormUrl, setCallbackFormUrl] = useState("");
  const [surveyLink, setSurveyLink] = useState("");
  const [satmatrixSurvey, setSatmatrixSurvey] = useState(false);
  const [satmatrixSurveyIFrame, setSatmatrixSurveyIFrame] = useState(false);
  const [isAgentInitiated, setAgentInitiated] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [receiverOrigin, setreceiverOrigin] = useState('*');
  const [cookieSetData, setCookieSetData] = useState(false);
  const context = useContext(AppContext);
  const surveyPageShow = useRef(false);
  const [localMaximized, setLocalMaximized] = useState(isMaximised);

  const resizeWindowScreen_Latest=()=>{
    const rootMax = document.querySelector('.root-max');
    // Get window width
    if(rootMax){
    document.getElementById("root").removeAttribute("style");
    const windowWidth = window.screen.width;
    console.log(windowWidth,"..windowWidth");
    if(window.config.isAccessibilityFeature){
    document.getElementById("root").classList.remove("adjustResize");
    }
    if(window.config.isAdjustable){
    if(getCookie(window.config.businessUnit + '-adjustResize')){
      if(window.config.isAccessibilityFeature){
      document.getElementById("root").classList.add("adjustResize");
      }
      if (windowWidth >= 1601) {
        rootMax.style.width = '800px';
        rootMax.style.height = '750px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '700px';
        rootMax.style.height ='525px';
      }
    }
    else{
      if (windowWidth >= 1601) {
        rootMax.style.width = '425px';
        rootMax.style.height = '600px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '375px';
        rootMax.style.height ='500px';
      }
    }
    }
    else{
      if (windowWidth >= 1601) {
        rootMax.style.width = '425px';
        rootMax.style.height = '600px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '375px';
        rootMax.style.height ='500px';
      }
    }
    // Apply styles based on window width
    
    }
    else{
    window.parent.postMessage({key:'minimise', launcherIcon: false}, window.config.pageOrigin);
    }
  }
  document.addEventListener("DOMContentLoaded", function () {
    console.log("111");
    //applyStyles();
  });
  document.addEventListener("beforeunload", function () {
    sessionStorage.removeItem("cwaSSOToken");
  });

  window.addEventListener("load", event => {
    sessionStorage.setItem('notification', false);
    sessionStorage.setItem('proactiveInactivity', Date.now());
    sessionStorage.removeItem("chatbotActive");
    sessionStorage.removeItem("proactiveBotAutoOpened");
    if (event.origin !== window.config.pageOrigin)
      return;
  });
   function loadScript(url) {
    // Create a script element
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;

    // Append the script to the body or head of the document
    document.head.appendChild(script);
  }
  useEffect(() => {
    let browserName = (function (agent) {
      switch (true) {
        case agent.indexOf("edge") > -1: return "Edge";
        case agent.indexOf("edg/") > -1: return "Edge";
        case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
        case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
        case agent.indexOf("trident") > -1: return "IE";
        case agent.indexOf("firefox") > -1: return "Firefox";
        case agent.indexOf("safari") > -1: return "Safari";
        default: return "other";
      }
    })(window.navigator.userAgent.toLowerCase());
    const triggerProactiveBot = (headerRef) => {
      if (
        disableProactivity() ||
        window.config.proactiveInactivityTriggered ||
        !headerRef.current
      ) return;

      window.config.proactiveInactivityTriggered = true;
      headerRef.current.botIconClick();
    };
    const callBotClick = (headerRef) => {
      if (
        disableProactivity() ||
        window.config.proactiveInactivityTriggered
      ) return;
      const proactiveInactivity = sessionStorage.getItem("proactiveInactivity");

      if (proactiveInactivity) {
        const savedTime = Number(proactiveInactivity); // Convert the stored timestamp to a number
        const currentTime = Date.now();
        const timeElapsed = currentTime - savedTime;

        // Set a 20-second delay condition
        const proactiveDelay = window.config.subscriptionDelay; // 20 seconds
        const remainingTime = proactiveDelay - timeElapsed;

        if (remainingTime <= 0) {
          // 20 seconds have passed, trigger botIconClick immediately
          triggerProactiveBot(headerRef);
        } else {
          // Wait for the remaining time and then trigger botIconClick
          setTimeout(() => {
            triggerProactiveBot(headerRef);
          }, remainingTime);
        }
      } else {
        // Fallback if proactiveInactivity isn't set (rare case)
        const currentTime = Date.now();
        sessionStorage.setItem("proactiveInactivity", currentTime); // Save current time
        setTimeout(() => {
          triggerProactiveBot(headerRef);
        }, window.config.subscriptionDelay);
      }
    }  
    window.parent.postMessage({ key: 'init_cwa_sso', origin: window.location.origin }, receiverOrigin);
    window.onmessage = async (e) => {
      const data = JSON.parse(JSON.stringify(e.data));

      switch (data.key) {
        case 'init_cwa_sso':
          localStorage.setItem("pageUrl", data.pageUrl);

          let SBG = '';
          let isFAQ2_0 = false;
          let showGenAIResponse = false;
          let localConfig = '';
          let isAEM = false;
          let isChina = false;
          let autoOpen = false;
          switch (data.value) {

            case 'https://accstorefront.cimkplqapn-honeywell1-d1-public.model-t.ccv2prod.sapcloud.cn':
            case 'https://stage.myhoneywell.com.cn':
              SBG = 'HBT';
              isChina = true;
              localConfig = hbtChinaNonprodConfig;
              break;
            case 'https://myhoneywell.com.cn':
              SBG = 'HBT';
              isChina = true;
              localConfig = hbtChinaProdConfig;
              break;
            case 'https://dpublish-hbt.aws.aem.honeywell.com':
            case 'https://qpublish-hbt.aws.aem.honeywell.com':
            case 'https://buildingsbt.stage.honeywell.com':
            case 'https://buildingsbt.baseline.uat.honeywell.com':
            case 'https://stageportal.buildings.honeywell.com':
              SBG = 'HBT';
              localConfig=hbtNonprodConfig;
              if(data?.pageUrl?.toLowerCase().includes("/subscriptions")){
                autoOpen=true;
              }
              break;
            case 'https://buildings.honeywell.com':
            case 'https://portal.buildings.honeywell.com':
              SBG = 'HBT';
              localConfig = hbtProdConfig;
              if (data.pageUrl.toLowerCase().includes("/subscriptions")) {
                autoOpen = true;
              }
              break;
            case 'https://dcaspsext-honeywellaidc.cs90.force.com':
            case 'https://sfq-honeywellaidc.cs63.force.com':
              SBG = 'SPS_TS';
              localConfig = spsTsNonprodConfig;
              break;
            case 'https://support.honeywellaidc.com':
              SBG = 'SPS_TS';
              localConfig = spsTsProdConfig;
              break;
            case 'https://qa-niagara.cs122.force.com':
            case 'https://niagara--qa.sandbox.my.site.com':
              SBG = 'HCE_TRIDIUM';
              localConfig = hceTridiumNonprodConfig;
              break;
            case 'https://www.niagara-community.com':
              SBG = 'HCE_TRIDIUM';
              localConfig = hceTridiumProdConfig;
              break;
            case 'https://uop.stage.honeywell.com':
            case 'https://qpublish-uop.aws.aem.honeywell.com':
             SBG = 'PMT_UOP';
              localConfig = pmtUopNonprodConfig;
              //console.log(performance.now(), "start time")
              //let decrypted = await decryptText(pmtUopNonprodConfig.encrypted);
              //console.log(performance.now(), "end time")
              //console.log(`Decryption took ${(end - start).toFixed(2)} ms`);
              //localConfig = JSON.parse(decrypted);
              if (data.value.includes('/shop')) {
                isAEM = false
              } else {
                isAEM = true;
              }
              break;
            case 'https://uop.honeywell.com':
              SBG = 'PMT_UOP';
              localConfig = pmtUopProdConfig;
              if (data.value.includes('/shop')) {
                isAEM = false
              } else {
                isAEM = true;
              }
              break;
            case 'https://qpublish-process.aws.aem.honeywell.com':
            case 'https://process.stage.honeywell.com':
              SBG = 'PMT_HPS';
              localConfig = pmtHpsNonprodConfig;
              break;
            case 'https://process.honeywell.com':
              SBG = 'PMT_HPS';
              localConfig = pmtHpsProdConfig;
              break;
            case 'https://dcaspsgdm-honeywell-sps.cs29.force.com':
            case 'https://honspsqa-honeywell-sps.cs215.force.com':
            case 'https://hon-sps--honspsqa.sandbox.my.site.com':
              SBG = 'SPS_GDM';
              localConfig = spsGdmNonprodConfig;
              break;
            case 'https://sps-support.honeywell.com':
              SBG = 'SPS_GDM';
              localConfig = spsGdmProdConfig;
              break;
            case 'https://sps-stage2.honeywell.com':
            case 'https://stage-sps.honeywell.com':
            case 'https://qpublish-automation.aws.aem.honeywell.com':
            case 'https://automation.baseline.uat.honeywell.com':
            case 'https://automation.stage.honeywell.com':
              const urlData = data.pageUrl;
              if (urlData.includes("https://sps-stage2.honeywell.com") || urlData.includes("https://stage-sps.honeywell.com") || (urlData.includes("https://automation.baseline.uat.honeywell.com") && urlData.includes('/shop')) || (urlData.includes("https://automation.stage.honeywell.com") && urlData.includes('/shop')) || (urlData.includes("https://qpublish-automation.aws.aem.honeywell.com") && urlData.includes('/shop'))) {
                SBG = 'SPS_ECOMM';
              }
              localConfig = spsEcommNonprodConfig;
              break;
            case 'https://corp-cx-da-nondprod-portal.azurewebsites.net':
              let isFAQ2_0, showGenAIResponse;
              if (data.pageUrl.startsWith('https://corp-cx-da-nondprod-portal.azurewebsites.net/apchatbot')) {
                SBG = 'HBT';
                isFAQ2_0 = true;
              }
              else if (data.pageUrl.startsWith('https://corp-cx-da-nondprod-portal.azurewebsites.net/faq2.0HPS')) {
                SBG = 'PMT_HPS';
                localConfig = pmtHpsNonprodConfig;
                isFAQ2_0 = true;

              }
              else {
                SBG = 'SPS_ECOMM';
                isFAQ2_0 = true
                showGenAIResponse = data.pageUrl.startsWith('https://corp-cx-da-nondprod-portal.azurewebsites.net/faq2.0GenAIResponse') ? true : false
                localConfig = spsEcommNonprodConfig;

              }
              break;

            case 'https://sps.honeywell.com':
            case 'https://automation.honeywell.com':
              SBG = 'SPS_ECOMM';
              const urlDataSet = data.pageUrl;
              if ((urlDataSet.includes("https://automation.honeywell.com") && urlDataSet.includes('/shop'))) {
                SBG = 'SPS_ECOMM';
              }
              if (SBG === 'SPS_ECOMM') {
                localConfig = spsEcommProdConfig;
              }
              break;
            case 'https://qapsupplierportal.honeywell.com':
              SBG = 'AP';
              break;
            default:
              SBG = '';
              break;
          }

          if (SBG === 'PMT_HPS' || SBG === 'SPS_ECOMM'  || SBG === 'HBT' || SBG === 'PMT_UOP' || SBG=='HCE_TRIDIUM' || SBG=='SPS_GDM'  || SBG=='SPS_TS') {
            let decrypted = await decryptText(localConfig.encrypted);
            window.config = JSON.parse(decrypted);
            window.config.autoOpen=autoOpen;
            window.config.isFAQ2 = isFAQ2_0 //for running faq2.0 ui with different app service abckend.
            window.config.showGenAIResponse = showGenAIResponse;
            window.config.isCanada =false;
            if (window.config.isGlassBoxIntegration) {
            loadScript(window.config.glassBoxScript);
            }
          } else {
            const response = await fetch(`${window.location.origin}/config.json?SBG=${SBG}`, {
              'headers': {
                "Origin": data.value,
              }
            });
            window.config = await response.json();
          }

          window.config.isAEM = isAEM;
          window.config.isChina = isChina;
          window.config.isDev = isFAQ2_0;

          if (window.config.isNewSSO) {
            window.config.isNewSSO = (SBG == 'PMT_UOP') ? isAEM : window.config.isNewSSO //for Adm and UOP non aem pages should use old authentication.
          }
          window.config.showTypingIndicator = true;
          window.config.isDefaultWorkflowClicked = false;
          window.config.elementsCount = 0;
          window.config.language = "en";
          window.config.countrySelectedOnPortal = "us"; //make it us later
          setCWACookies('cwaSSOToken', "Anonymous", 100000); //uncomment it later
          window.config.portalPageUrl = data.pageUrl;
          window.config.sessionRefreshed = data.sessionRefreshed;
          window.config.pageOrigin = data.value;
          window.config.browserName = browserName;
          setIsDisplay(true);
          if(window.config.isNewSSO) {
            window.parent.postMessage({ key: 'display_chatbot', businessUnit:window.config.businessUnit,cookieUrl:window.config.cookieUrl,cookieKey:window.config["3469726563746c696e650k08"].split("&=")[1],jwtTokenName:window.config.isChina ? window.config.jwtTokenNameHybris:window.config.jwtTokenName,pageOrigin:window.config.pageOrigin,cardpageOrigin:"*" }, window.config.pageOrigin);
            window.parent.postMessage({ key: 'chat_bot_loaded', businessUnit:window.config.businessUnit,cookieUrl:window.config.cookieUrl,cookieKey:window.config["3469726563746c696e650k08"].split("&=")[1],jwtTokenName:window.config.isChina ? window.config.jwtTokenNameHybris:window.config.jwtTokenName,pageOrigin:window.config.pageOrigin,cardpageOrigin:"*" }, window.config.pageOrigin);
          }
          else if (window.config.businessUnit === 'HCE-TRIDIUM' || window.config.businessUnit === 'SPS-GDM') {
            window.parent.postMessage({ key: 'display_chatbot', businessUnit: window.config.businessUnit, cookieUrl: window.config.cookieUrl, cookieKey: window.config["3469726563746c696e650k08"].split("&=")[1], jwtTokenName: window.config.isChina ? window.config.jwtTokenNameHybris : window.config.jwtTokenName, pageOrigin: window.config.pageOrigin, cardpageOrigin: "*" }, window.config.pageOrigin);
          }
          break;
        case 'cwa_sso_token_set':
          if (!data.value) {
            data.value = 'Anonymous';
          }
          setCWACookies('cwaSSOToken', data.value, 100000);
          window.config.pageTitle = data.pageTitle;
          window.config.language = data.pageLanguage;
          window.config.countrySelectedOnPortal = data.countrySelectedOnPortal;
          window.config.portalPageUrl = data.pageUrl;
          window.config.sessionRefreshed = data.sessionRefreshed;
          break;
        case 'cwa_cookies_http':
          if(!window.config.removedCookie && getCookie(`${window.config.businessUnit}-AuthToken`) && getCookie(`${window.config.businessUnit}-AuthToken`) != data.value){
           window.config.removedCookie=true;
           removeDLCookies("sessiontimeout");
          }
          console.log(data.pageTitle,"..data");
          setCWACookies('cwaSSOToken', data.value, 100000);
          setCookie(`${window.config.businessUnit}-AuthToken`, data.value);
          window.config.estimatedWaitTime = null;
          window.config.pageTitle = data.pageTitle;
          window.config.isProactiveEnable = data.isProactiveEnable;
          window.config.pageBigIconArray = data.pageBigIconArray;
          window.config.selectedCurrency=data.selectedCurrency;
          window.config.isLanguageEnabled = data.isLanguageEnabled;
          if(window.config.isChina){
            window.config.countrySelectedOnPortal = "CN";
            data.countrySelectedOnPortal ="CN";
            window.config.language = data.pageLanguage ? data.pageLanguage : "en";
          }
          else if(data.countrySelectedOnPortal=="ca" && window.config.businessUnit == "HBT-GCEGBT" && data.pageLanguage!="en" )
          {
            window.config.isCanada = true;
            window.config.language = `${data.pageLanguage}-${data.countrySelectedOnPortal}`;
            console.log(window.config.language,"..sdfs")
          }
          else {
            console.log(window.config.language,"..11sdfs")
            window.config.language = data.pageLanguage ? data.pageLanguage : "en";
          }
          window.config.countrySelectedOnPortal = data.countrySelectedOnPortal ? data.countrySelectedOnPortal : "us";
          window.config.portalPageUrl = data.pageUrl;
          window.config.sessionRefreshed = data.sessionRefreshed;
          window.config.b2bunit = data.b2bunit;
          window.config.dp = data.dp;
          window.config.redirectIndicator = data.dataRedirect;
          window.config.coveoId = data.coveoId;
          window.config.isSalesPage = data.isSalesPage;
          context.setPageTitleCookie(data.pageTitle);
          if(window.config.isCanada){
           context.setPageLanguage(window.config.language);
          }
          else{
          context.setPageLanguage(data.pageLanguage);
          }
          context.setCountrySelectedOnPortal(data.countrySelectedOnPortal);
          if (window.config.redirectIndicator && window.config.redirectIndicator.includes("PartnerPortal") && !sessionStorage.getItem("proactiveBotAutoOpened")) {
            const businessUnit = window.config.businessUnit;
            const isAuthenticated = getCookie(`${businessUnit}-Token`) &&
              getCookie(`${businessUnit}-Conversation`) &&
              getCookie(`${businessUnit}-AuthToken`) &&
              getCWACookies('cwaSSOToken') &&
              getCookie(`${businessUnit}-AuthToken`).length === getCWACookies('cwaSSOToken').length &&
              getCookie(`${businessUnit}-Language`) &&
              getCookie(`${businessUnit}-Language`) === window.config.language;
            if (!isAuthenticated) {
              if (headerRef.current) {
                sessionStorage.setItem("proactiveBotAutoOpened", "true");
                callBotClick(headerRef);
              }
            }
          } 
          break;
        case 'open_chatbot':
          if (headerRef.current) {
            headerRef.current.botIconClick();
          }
          break;
        default:
          break;
      }
    };
    sessionStorage.removeItem(window.config.businessUnit + '-SatmatrixSurveyOpen');
    const interval = setInterval(() => {
      if (getCookie(window.config.businessUnit + '-BotLastResponseTime') && document.getElementById("root").classList.contains("root-max")) {
        const botLastResponseTime = new Date(getCookie(window.config.businessUnit + '-BotLastResponseTime'));
        const currentTime = new Date();
        const diff = Math.abs(currentTime.getTime() - botLastResponseTime.getTime()) / 60000;
        const diffCheck = window.config.sessionIdle? window.config.sessionIdle:15;
        if (diff > diffCheck) {
          showModal(true);
          // if(window.config.isAttachment){
          // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
          // sessionStorage.removeItem(ATTACHMENTS_KEY);
          // }
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
          if (window.config.isNewPrivacy) {
          eraseCookie(window.config.businessUnit + '-isPrivacyAccepted');
          }
          if (window._dcaStore) {
            window._dcaStore.dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "sessionTimeout",
                value: { businessUnit: window.config.businessUnit }
              }
            });
          }
          removeDLCookies("sessiontimeout");
        }
      }
    }, 10 * 1000);
    return () => { clearInterval(interval); };
  }, []);

  const accessToken = getCWACookies("cwaSSOToken");

  function setDirectLineToken() {
    const isPrivacyAccepted = getCookie(window.config.businessUnit + '-isPrivacyAccepted');
    if (!window.config.isNewPrivacy || isPrivacyAccepted) {
      setDirectLineTokenCall();
    }
  }
  function capitalizeFirstLetter(string){
    return string
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  function formatWaitTime(valueInMinutes,hoursText,hourText,minutesText,minuteText) {
    if (valueInMinutes >= 60) {
        const hours = Math.floor(valueInMinutes / 60);
        const minutes = valueInMinutes % 60;
      return hours > 1
        ? `${hours} ${hoursText} ${(minutes > 1 ? minutesText : minuteText)}`
        : `${hours} ${hourText} ${(minutes > 1 ? minutesText : minuteText)}`;
    } else {
        return `${valueInMinutes} ${(valueInMinutes > 1 ? minutesText : minuteText)}`;
    }
}
  function AMPMFormat(date) {
  var hours = date.getHours();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; 
  return { hour: hours, ampm: ampm };
}
  function GreetUser(userLanguage) {
  const timeFormat = AMPMFormat(new Date());
  if (timeFormat.ampm === "AM") {
    return userLanguage
      ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodMorning)
      : capitalizeFirstLetter("good morning");
  } else {
    if (timeFormat.hour >= 4 && timeFormat.hour <= 7) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodEvening)
        : capitalizeFirstLetter("good evening");
    }
    if (timeFormat.hour >= 1 && timeFormat.hour <= 4) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodAfternoon)
        : capitalizeFirstLetter("good afternoon");
    }

    if (timeFormat.hour === 12) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodAfternoon)
        : capitalizeFirstLetter("good afternoon");
    }

    if (timeFormat.hour > 7 && timeFormat.hour) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodEvening)
        : capitalizeFirstLetter("good evening");
    }
  }
}
  function setDirectLineTokenCall() {
    const businessUnit = window.config.businessUnit;
    const isHBTorSPS = (businessUnit === 'HBT-GCEGBT' || businessUnit === 'SPS-ECOMM');
    const isAuthenticated = getCookie(`${businessUnit}-Token`) && 
                            getCookie(`${businessUnit}-Conversation`) &&
                            getCookie(`${businessUnit}-AuthToken`) && 
                            getCWACookies('cwaSSOToken') &&
                            getCookie(`${businessUnit}-AuthToken`).length === getCWACookies('cwaSSOToken').length &&
                            getCookie(`${businessUnit}-Language`) && 
                            getCookie(`${businessUnit}-Language`) === window.config.language;
   
    if (isAuthenticated) {
        const token = getCookie(`${businessUnit}-Token`);
        setDirectLine(createDirectLine({ token }));
        if (isHBTorSPS || window.config.isPersisted) {
            setCookie(`${businessUnit}-OldCoversation`, true);
            setCookie(`${businessUnit}-botMaximiseTime`, Date.now());
        }
    } else {
        removeDLCookies(false);
        if(!cookieSetData){
          window.parent.postMessage({ key: 'chat_bot_loaded', businessUnit:window.config.businessUnit,cookieUrl:window.config.cookieUrl,cookieKey:window.config["3469726563746c696e650k08"].split("&=")[1],jwtTokenName:window.config.isChina ? window.config.jwtTokenNameHybris:window.config.jwtTokenName,pageOrigin:window.config.pageOrigin,cardpageOrigin:"*" }, window.config.pageOrigin);
          setCookieSetData(true);  
        }
        getDirectLineToken()
            .then((result) => {
                const token = result.token;
                setDirectLine(createDirectLine({ token }));

                if (isHBTorSPS || window.config.isPersisted) {
                    setCookie(`${businessUnit}-Token`, token);
                    setCookie(`${businessUnit}-AuthToken`, getCWACookies('cwaSSOToken'));
                    setCookie(`${businessUnit}-OldCoversation`, false);
                    setCookie(`${businessUnit}-Language`, window.config.language);
                }
            })
            .catch((error) => {
                if (appInsights) {
                    appInsights.trackTrace({
                        message: 'Exceptions',
                        properties: {
                            name: 'Direct line error',
                            message: error.message,
                            stack: error.stack
                        }
                    });
                }
            });
    }
    refreshDLToken();
  }
  const removeDLCookies = (timeout) => {
    eraseCookie(window.config.businessUnit + '-Token');
    eraseCookie(window.config.businessUnit + '-Conversation');
    eraseCookie(window.config.businessUnit + '-botMaximise');
    eraseCookie(window.config.businessUnit + '-AuthToken');
    eraseCookie(window.config.businessUnit + '-OldCoversation');
    eraseCookie(window.config.businessUnit + '-Language');
    eraseCookie(window.config.businessUnit + '-EnableSendBox');
    eraseCookie(window.config.businessUnit + '-BotLastResponseTime');
    eraseCookie(window.config.businessUnit + '-botMaximiseTime');
    eraseCookie(window.config.businessUnit + '-CheckOrderLob');
    eraseCookie(window.config.businessUnit + '-CheckOriginalId');
    eraseCookie(window.config.businessUnit + '-WebPopup');
    if(window.config.isAttachment){
    const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
    sessionStorage.removeItem(ATTACHMENTS_KEY);
      }
    if (timeout && timeout == "sessiontimeout") {
     
      if (getCookie(window.config.businessUnit + '-adjustResize') && window.config.isAdjustable == true) {
        eraseCookie(window.config.businessUnit + '-adjustResize');
      }
    }
  };

  const refreshDLToken = () => {
    setInterval(() => {
      if (getCookie(window.config.businessUnit + '-Token')) {
        getRefreshDirectLineToken();
      }
    }, 20 * 60 * 1000);
  };

  const handleSpinnerChange = useCallback(() => {
    setSpinner(!showSpinner);
  }, [showSpinner, setSpinner]);

  const handleSurveyCardChange = useCallback(
    event => {
      if (isSurveyOpen) {
        setSurveyFlag(!isSurveySubmitted);
        // setDirectLine(null);
        // setStore(null);
        context.setLiveAgent(false);
      }
      showSurvey(!isSurveyOpen);
    },
    [
      isSurveySubmitted,
      isSurveyOpen,
      setSurveyFlag,
      showSurvey,
      // setDirectLine,
      // setStore
      setLiveAgent
    ]
  );

  const handleRefreshModalPopup = useCallback(event => {
    if (isSurveyOpen) {
      showSurvey(false);
    }
    showModal(false);
    showErrorPage({ isErrorOccured: false, message: "" });
    setSpinner(true);
    context.setLiveAgent(false);
    setAgentInitiated(false);
    context.setShowSendBox(false);
    context.setDisableSendBox(true);
    context.setEnableSendBoxHBT(false);
    setShowTimerBox(false);
    context.setShowHeaderFooter(false);
    context.setEnableScroll(false);
    setUserLanguage("");
    context.setOptionSelected(false);
    context.setHideStickyMenu(false);
    context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
  },
    [setDirectLineToken, setUserLanguage, setShowTimerBox, setAgentInitiated, setLiveAgent]
  );

  const closeLiveAgentProps = () => {
    setShowTimerBox(false);
    context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
    context.setUsersCount(0);
  }
  const handleMaximizeChange = useCallback(() => {
    if (!directLine) {
      // We will load DirectLineJS asynchronously on first render.
      setDirectLineToken();
    }
    if (!isMaximised) {
      sessionStorage.setItem("chatbotActive", true);
      sessionStorage.setItem('notification', true);

      if (context.showHeaderFooter !== true) {
        context.setShowHeaderFooter(false);
        context.setShowSendBox(false);
      }

      //On Survey submit we are refreshing the bot conversation.
      if (isSurveySubmitted) {
        handleSpinnerChange();
        setSurveyFlag(!isSurveySubmitted);
        removeDLCookies(false);
        setDirectLine(null);
        setStore(null);
        setDirectLineToken();
        setHeaderIconsDisplay(true);
        setUserLanguage("");
        closeLiveAgentProps();
        context.setDisableSendBox(true);
        context.setEnableSendBoxHBT(false);
      }
      document.getElementById("root").classList.add("root-max");
      document.getElementById("root").classList.remove("root-min");
      document.getElementById("main").classList.remove("main-min");
      document.getElementById("main").classList.add("main-max");
      resizeWindowScreen_Latest();
      context.setMenuOpen(false);
      window.parent.postMessage({ key: 'maximise', isAdjustable: window.config.isAdjustable, adjustResize: getCookie(window.config.businessUnit + '-adjustResize') }, window.config.pageOrigin);
      setTimeout(() => {
        if (document.getElementById("web-chat") && !isMaximised) {
          document.getElementById(
            "web-chat"
          ).scrollTop = document.getElementById("web-chat").scrollHeight;
        }
      }, 0);
    } else {
      context.setMenuOpen(false);
      sessionStorage.setItem('notification', false);
      sessionStorage.removeItem("chatbotActive");
      document.getElementById("root").removeAttribute("style");
      document.getElementById("root").classList.remove("root-max");
      document.getElementById("main").classList.remove("main-max");
      document.getElementById("main").classList.add("main-min");
      window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
    }

    setMaximizeflag(!isMaximised);
    if (window.config.businessUnit === 'HBT-GCEGBT' || window.config.isPersisted) {
      setCookie(window.config.businessUnit + '-botMaximise', !isMaximised);
    }
  }, [
    isMaximised,
    showSpinner,
    isSurveySubmitted,
    setMaximizeflag,
    handleSpinnerChange,
    setSurveyFlag,
    closeLiveAgentProps
  ]);
  const handleCloseModalPopup = useCallback(event => {
    setSurveyFlag(!isSurveySubmitted);
    setHeaderIconsDisplay(false);
    context.setLiveAgent(false);
    context.setOptionSelected(false);
    context.setShowGoBackbutton(true);
    context.setHideStickyMenu(false);
    context.setShowHeaderFooter(false);
    context.setEnableScroll(false);
    sessionStorage.removeItem("chatbotActive");
    sessionStorage.setItem('notification', false);
    context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
    showModal(false);
    context.setIsAccountChanged(false);
    removeDLCookies(false);
  }, [handleMaximizeChange, setSurveyFlag]);

  const handleCloseBotInTabs = useCallback(() => {
    context.setMenuOpen(false);
    sessionStorage.setItem('notification', false);
    sessionStorage.removeItem("chatbotActive");
    document.getElementById("root").removeAttribute("style");
    document.getElementById("root").classList.remove("root-max");
    document.getElementById("main").classList.remove("main-max");
    document.getElementById("main").classList.add("main-min");
    window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
    setMaximizeflag(false);
    window.history.go(0);
  }, [
    isMaximised,
    isSurveySubmitted
  ]);

  const handleModalChange = useCallback(
    actionItem => event => {
      context.setMenuOpen(false);
      window.config.hideTextBox=false;
      if (actionItem.target === "refresh") {
        if (actionItem.backMenu) {
          context.setMenuOpen(true);
        }
        if (actionItem.value) {
          if (actionItem.value === "Yes") {
            if (isSurveyOpen) {
              showSurvey(false);
            }
            removeDLCookies(false);
            setDirectLine(null);
            setStore(null);
            showErrorPage({ isErrorOccured: false, message: "" });
            setSpinner(true);
            context.setLiveAgent(false);
            context.setChatLeftStart(false);
            setAgentInitiated(false);
            context.setShowSendBox(false);
            context.setDisableSendBox(true);
            context.setEnableSendBoxHBT(false);
            setShowTimerBox(false);
            context.setShowHeaderFooter(false);
            context.setEnableScroll(false);
            setDirectLineToken();
            setUserLanguage("");
            context.setOptionSelected(false);
            context.setHideStickyMenu(false);
          }
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        } else {
          context.setModalProps({ refresh: true, close: false, quitAgentQueue: false, busyNotification: false });
        }
      }

      if (actionItem.target === "closeWithSurvey") {
        handleSurveyCardChange();
        setHeaderIconsDisplay(false);
        context.setShowHeaderFooter(false);
        context.setEnableScroll(false);
      }

      if (actionItem.target === "close") {
        if (actionItem.value) {
          if (store != null) {
            store.dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "feedbackCancelButton"
              }
            });
          }
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        }
        else {
          context.setModalProps({ refresh: false, close: true, quitAgentQueue: false, busyNotification: false });
        }
      }

      if (actionItem.target === "closeLaunchIcon") {
        handleMaximizeChange();
        handleCloseModalPopup();
      }

      if (actionItem.target === "QuitandCreateTicket") {
        // if (actionItem.value) {
        //   if (actionItem.value === "Yes") {
        cancelSession();
        handleSurveyCardChange();
        window.open(callbackFormUrl, "_blank");
        //   } else {
        //     context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        //   }
        // } else {
        //   context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
        // }
      }

      if (actionItem.target === "QuitAgentQueue") {
        // if (actionItem.value) {
        //   if (actionItem.value === "Yes") {
        cancelSession();
        handleSurveyCardChange();
        setHeaderIconsDisplay(false);
        context.setShowHeaderFooter(false);
        context.setShowGoBackbutton(false);
        context.setEnableScroll(false);
        window.open(callbackFormUrl, "_blank");
        //   } else {
        //     context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        //   }
        // } else {
        //   context.setModalProps({ refresh: false, close: false, quitAgentQueue: true, busyNotification: false });
        // }
      }

      if (actionItem.target === "shutdown") {
        // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
        // sessionStorage.removeItem(ATTACHMENTS_KEY);
        setSurveyLink("");
        setSatmatrixSurvey(false);
        setSatmatrixSurveyIFrame(false);
        handleSurveyCardChange();
        handleMaximizeChange();
        context.setLiveAgent(false);
        context.setShowHeaderFooter(false);
        sessionStorage.removeItem("chatbotActive");
        sessionStorage.removeItem(window.config.businessUnit + '-SatmatrixSurveyOpen');
        window.history.go(0);
      } else {
        showModal(isMaximised && actionItem.isOpenModal);
      }
    },
    [isMaximised, isSurveyOpen, showModal, showSurvey, handleSurveyCardChange, callbackFormUrl, setSurveyLink, setSatmatrixSurvey, setSatmatrixSurveyIFrame, setLiveAgent]
  );


  // async function openInNewTab(href){
  //   const anchorDoc=Object.assign(document.createElement('a'),{});
  //   return anchorDoc;
  // }
  async function cancelSession() {
    // const agentSessionId = sessionStorage.getItem("AgentSessionID");
    // if (agentSessionId != null) {
    //   const response = await getAgentToken(agentSessionId);
    //   return response;
    // }
    // if(window.config.isAttachment){
    //       const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
    //       sessionStorage.removeItem(ATTACHMENTS_KEY); 
    //       }
    if (isAgentInitiated) {
      if (store != null) {
        store.dispatch({
          type: "WEB_CHAT/SEND_EVENT",
          payload: {
            name: "CancelSession"
          }
        });
      }
    }
  }
  const isMobileDevice = () => {
  const userAgent = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  };
  async function getDirectLineToken() {
    const res = await getToken();
    return (res.data && res.data.token) ? res.data : null;
  }

  async function getRefreshDirectLineToken() {
    const res = await getRefreshToken();
    if (res.data && res.data.token) {
      setCookie(window.config.businessUnit + '-Token', res.data.token);
    }
    else {
      removeDLCookies(false);
    }
  }

  let isRejectedActivity = false;
  if (!store) {
    const newStore = window.WebChat.createStore({}, ({ dispatch }) => next => async action => {
        setTimeout(() => {
          if (document.getElementById("web-chat")) {
            document.getElementById(
              "web-chat"
            ).scrollTop = document.getElementById("web-chat").scrollHeight;
          }
        }, 0);

        if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
          console.log("Bot webchat/join:", Date.now());
            const portalName = (window.config.isAEM) ? window.config.portalNameAEM : window.config.portalName;
            let dataDispatch= {
                  language: (window.config.businessUnit === 'HBT-GCEGBT' || window.config.businessUnit === 'SPS-ECOMM') ? window.config.language : window.navigator.language,
                  countrySelectedOnPortal: window.config.countrySelectedOnPortal,
                  accessToken: getCWACookies("cwaSSOToken"),
                  sbg: window.config.sbg,
                  gbe: window.config.gbe,
                  portalName: (window.config.businessUnit === 'HBT-GCEGBT' || window.config.businessUnit === 'SPS-ECOMM') ? portalName.replace('/en/', '/' + window.config.language + '/') : portalName,
                  browserTime: new Date(),
                  pageTitle: window.config.pageTitle,
                  portalPageUrl: window.config.portalPageUrl,
                  browserName: window.config.browserName,
                  isOldConversation: getCookie(window.config.businessUnit + '-OldCoversation') ? true : false,
                  encryptedSoldToAccount: window.config.b2bunit,
                  isAEM: window.config.isAEM,
                  isNewSSO: window.config.isNewSSO,
                  isChina: window?.config?.isChina,
                  isCanada: window?.config?.isCanada?true:false,
                  pageUrl: (window.config.businessUnit === 'HBT-GCEGBT') ? localStorage.getItem("pageUrl"):null,
                  selectedCurrency: (window.config.businessUnit === 'HBT-GCEGBT') ? window.config.selectedCurrency : null,
                  coveoId:window.config.coveoId?window.config.coveoId:null
            }
            if(window.config.mobileAdd){
            dataDispatch.deviceType = isMobileDevice() ? 1:0
            }
            dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "webchat/join",
                value:dataDispatch
              }
            });
          
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "openWebform"
        ) {
          if (getCookie(window.config.businessUnit + '-OldCoversation')) {
            if (getCookie(window.config.businessUnit + '-botMaximiseTime')) {
              const date1 = getCookie(window.config.businessUnit + '-botMaximiseTime');
              var difference = new Date().getTime() - date1;
              var minutesDifference = Math.floor(difference / 1000 / 60);
              difference -= minutesDifference * 1000 * 60;
              var secondsDifference = Math.floor(difference / 1000);
              if (secondsDifference > 15) {
                window.open(action.payload.activity.value, "_blank");
              }
            }
          } else {
            window.open(action.payload.activity.value, "_blank");
          }
        }

        if ( //To make webformpopup appear for LAC LOB selection Agent unavailable.
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "webFormPopupVisible"
        ) {
          context.setCaseWebFormArticleModal(action.payload.activity.value);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "refreshAcknowledge"
        ) {
          removeDLCookies("sessiontimeout");
          handleRefreshModalPopup();
          setDirectLine(null);
          setStore(null);
          setDirectLineToken();
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "closeAcknowledge"
        ) {
          if (getCookie(window.config.businessUnit + '-adjustResize') && window.config.isAdjustable == true) {
            eraseCookie(window.config.businessUnit + '-adjustResize');
          }
          if (document.getElementById("root").classList.contains("root-max") && !sessionStorage.getItem(window.config.businessUnit + '-SatmatrixSurveyOpen')) {
            handleCloseModalPopup();
            handleCloseBotInTabs();
          }
          else if (!sessionStorage.getItem(window.config.businessUnit + '-SatmatrixSurveyOpen')) {
            if(window.config.businessUnit!=="HBT-GCEGBT"){
            window.history.go(0);
            }     
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "signin/success"
        ) {
          if (document.getElementById("spinner-text")) {
            document.getElementById("spinner-text").innerHTML =
              "Gathering your information";
          }

          setSpinner(false);
          context.setMinimizeBot(false);

          if (action.payload.activity.value.status) {
            showErrorPage({ isErrorOccured: false, message: "" });
          } else {
            sessionStorage.removeItem("cwaSSOToken");
            if (getCookie(window.config.businessUnit + '-isPrivacyAccepted') && window.config.isNewPrivacy == true) {
              eraseCookie(window.config.businessUnit + '-isPrivacyAccepted');
            }
            if (getCookie(window.config.businessUnit + '-adjustResize') && window.config.isAdjustable == true) {
              eraseCookie(window.config.businessUnit + '-adjustResize');
            }
            showErrorPage({
              isErrorOccured: true,
              message: {
                text: "Login Failed",
                subText: "Your username and/or password do not match",
                link: {
                  text: "Retry",
                  src: (window.config.isAEM) ? `${window.config.portalUrlAEM}` : `${window.config.portalUrl}`,
                  target: "_parent"
                }
              }
            });
          }
        }

        if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "brandBasedPageConfirmation")
        {
            window.config.isBrandBasedPage = action.payload.activity.value.isBrandBasedPage;
            if(!getCookie(window.config.businessUnit + '-OldCoversation')) {
                dispatch({
                    type: "WEB_CHAT/SEND_POST_BACK",
                    payload: {
                        value: {
                            "isBrandBasedPage": action.payload.activity.value.isBrandBasedPage,
                            "brandGreetingMessage":`${GreetUser(window.config.language)}! `
                        }
                    }
                });

            context.setShowHeaderFooter(true);
            context.setShowSendBox(true);
            context.setEnableScroll(true);
            context.setHideStickyMenu(false);
            context.setMoreOptionsClick(false);
            setCookie(window.config.businessUnit + '-Conversation', true);
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "getCredsDetails"
        ) {
          window.config.documentDownloadAPI=action.payload.activity.value?.documentDownloadAPI;
          window.config.searchServiceApi=action.payload.activity.value?.searchServiceApi;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableAttachmentIcon"
        ) {
           window.config.isPartiallyAuthenticated = action.payload.activity.value;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "feedback"
        ) {
          if (window.config.businessUnit === "HCE-TRIDIUM") {
            dispatch({ //Send CloseBot event
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "closeWithFeedback",
                value: getCWACookies("cwaSSOToken")
              }
            });
          } else if (action.payload.activity.value.checkShowOrHideSurvey) {
            context.setShowSurvey(action.payload.activity.value.sendSurvey);
            surveyPageShow.current = action.payload.activity.value.sendSurvey;

            if (surveyPageShow.current) {
              handleSurveyCardChange();
              setHeaderIconsDisplay(false);
              context.setShowHeaderFooter(false);
              context.setEnableScroll(false);
            } else {
              showModal(true);
              context.setModalProps({ refresh: false, close: true, quitAgentQueue: false, busyNotification: false });
            }
          } else {
            handleSurveyCardChange();
            setHeaderIconsDisplay(false);
            context.setShowHeaderFooter(false);
            context.setEnableScroll(false);
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "feedbackGoBackButtonAck"
        ) {
          showSurvey(false);
          context.setOptionSelected(true);
          context.setShowHeaderFooter(true);
          context.setEnableScroll(true);
          setHeaderIconsDisplay(true);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "showDisclaimerLimit"
        ) {
         window.config.isDisclaimer=true;
         window.config.charLimit=true;
      }
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "progressIndicatorStart"
        ) {
          window.config.progressIndication=true;
          window.config.progressIndicationName=action.payload.activity.value;
        }
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "progressIndicatorStop"
        ) {
          window.config.progressIndication=false;
          window.config.progressIndicationName=action.payload.activity.value;
        }
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "hideDisclaimerLimit"
        ) {
         window.config.isDisclaimer=false;
         window.config.charLimit=false;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "feedbackCancelButtonAck"
        ) {
          showModal(false);
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "exitQueueButtonAck"
        ) {
          if (window.config.businessUnit==="HBT-GCEGBT" && !window.config.isChina)
          { console.log("user exited");
            window.config.hasDispatchedAgentEWT = false;
          }
          setShowTimerBox(false);
          context.setLiveAgent(false);
          context.setShowSendBox(true);
          context.setDisableSendBox(true);
          context.setEnableScroll(true);
          context.setHideStickyMenu(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "updatedFeedback"
        ) {
          if (window.config.businessUnit === "HCE-TRIDIUM") {
            context.setShowSurvey(action.payload.activity.value);
            surveyPageShow.current = action.payload.activity.value;

            if (surveyPageShow.current) {
              handleSurveyCardChange();
              setHeaderIconsDisplay(false);
              context.setShowHeaderFooter(false);
              context.setEnableScroll(false);
            }
            else {
              showModal(true);
              context.setModalProps({ refresh: false, close: true, quitAgentQueue: false, busyNotification: false });
            }
          }
          else {
            handleSurveyCardChange();
            setHeaderIconsDisplay(false);
            context.setShowHeaderFooter(false);
            context.setEnableScroll(false);
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "closeBot"
        ) {
          context.setMenuOpen(false);
          context.setMinimizeBot(false);

          sessionStorage.setItem('notification', false);
          sessionStorage.removeItem("chatbotActive");
          document.getElementById("root").removeAttribute("style");
          document.getElementById("root").classList.remove("root-max");
          document.getElementById("main").classList.remove("main-max");
          document.getElementById("main").classList.add("main-min");

          if (!JSON.parse(sessionStorage.getItem('notification'))) {
            window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
          }

          setMaximizeflag(isMaximised);

         
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "refresh"
        ) {
          showModal(true);
          context.setModalProps({ refresh: true, close: false, quitAgentQueue: false, busyNotification: false });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "userLanguage"
        ) {
          setUserLanguage(action.payload.activity.value);
          window.config.language = action.payload.activity.value;
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentsNotAvailable"
        ) {
          context.setShowSendBox(true);
          setShowTimerBox(false);
          setAgentInitiated(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentdisconnected"
        ) {
          context.setShowSendBox(false);
          setAgentInitiated(false);
          context.setLiveAgent(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentInitiated"
        ) {
          if (!window.config.isNewUI) {
            context.setShowSendBox(false);
            context.setHideStickyMenu(true);
            context.setDisableSendBox(false);
          }
          setAgentInitiated(true);
          setShowTimerBox(true);

          var callBackUrl = "";
          switch (window.config.sbg) {
             default:
              callBackUrl = window.config.customerSupportUrl;
          }

          setCallbackFormUrl(callBackUrl);

        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "webformPopup"
        ) {
          context.setWebformContent(action.payload.activity.value.content);
        }
         if (
           action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
           action.payload.activity.type === "event" &&
           action.payload.activity.name === "disableSendBox"
         ) {
           if(!context.isLiveAgent){
             context.setDisableSendBox(true);
           }
          if (window.config.businessUnit==="HBT-GCEGBT" && !window.config.isChina)
          {
           window.config.isTextArea=false;
          }
         }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "modalSubmitCancelled"
        ) {
          context.setCaseWebFormArticleModal(false);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableSendBox"
        ) {
          context.setDisableSendBox(false);
          setCookie(window.config.businessUnit + '-EnableSendBox', true);
          if (window.config.businessUnit==="HBT-GCEGBT" && !window.config.isChina)
          {
          window.config.isTextArea= action.payload.activity.value;
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableSendBoxEventAcknowledged"
        ) {
          context.setDisableSendBox(true);
          setCookie(window.config.businessUnit + '-EnableSendBox', false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableRestrictionInTextbox"
        ) {
          context.setRestrictTextBox(true);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableRestrictionInTextbox"
        ) {
          context.setRestrictTextBox(false);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "viewOriginalLineItemsButtonId"
        ) {
          const viewOriginalLineItemsButtonId = action.payload.activity.value.viewOriginalLineItemsButtonId;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableViewLineItemButton"
        ) {
          const viewLineItemsButtonId = action.payload.activity.value.viewLineItemsButtonId;
          if (document.getElementById(viewLineItemsButtonId)) {
            document.getElementById(viewLineItemsButtonId).disabled = true;
          }
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableConfirmLineItemButton"
        ) {
          let submitObject = {
            id: action.payload.activity.value.confirmLineItemsButtonId,
            ...action.payload.activity.value.geographyValue
          }
          let checkHistory = getCookie(window.config.businessUnit + '-CheckOrderLob');
          if (checkHistory) {
            checkHistory = JSON.parse(checkHistory);
            if (Array.isArray(checkHistory)) {
              if (!checkHistory.map(i => i.id).includes(submitObject.id)) {
                setCookie(window.config.businessUnit + '-CheckOrderLob', JSON.stringify([...checkHistory, submitObject]))
              }
            }
          }
          else {
            setCookie(window.config.businessUnit + '-CheckOrderLob', JSON.stringify([submitObject]))
          }
          const confirmLineItemsButtonId = action.payload.activity.value.confirmLineItemsButtonId;
          if (document.getElementById(confirmLineItemsButtonId)) {
            document.getElementById(confirmLineItemsButtonId).disabled = true;
          }
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableViewOriginalLineItemButton"
        ) {
          const viewOriginalLineItemsButtonId = action.payload.activity.value;
          setTimeout(() => {
            if (document.getElementById(viewOriginalLineItemsButtonId)) {
              document.getElementById(viewOriginalLineItemsButtonId).style.display = "none";
            }
          }, 500);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableQnaSuggestionList"
        ) {
          const qnaSuggestionList = document.getElementsByClassName(action.payload.activity.value.qnaSuggestionListClassName);

          if (qnaSuggestionList.length > 0) {
            for (let i = 0; i < qnaSuggestionList.length; i++) {
              qnaSuggestionList[i].disabled = true;
            }
          }
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentEWT")
        ) {
          if (!window.config.hasDispatchedAgentEWT) {
            window.config.hasDispatchedAgentEWT = true;
            dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "EWTLogging",
                value: action.payload.activity.value
              }
            });
          }
          window.config.estimatedWaitTime = formatWaitTime(action.payload.activity.value,liveAgentStaticLabels[window.config.language].agentHours,liveAgentStaticLabels[window.config.language].agentHour,liveAgentStaticLabels[window.config.language].agentMinutes,liveAgentStaticLabels[window.config.language].agentMinute);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentattachment")
        ) {
          const {
            fileName,
            fileUrl,
            mimeType
          } = action.payload.activity.value;

          // Store on config for backward-compatibility
          window.config.attachMentUrl       = fileUrl || '';
          window.config.attachMentmimeType  = mimeType || '';
          window.config.attachMentFileName  = fileName || '';

          // Step 1: cache immediately from fileUrl (temporary URL).
          // This is the source used later for cache-only download.
          if (fileUrl) fetchAndCacheAttachment(fileUrl, fileName);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentjoined" || action.payload.activity.name === "agenttransfered")
        ) {
          if (window.config.businessUnit==="HBT-GCEGBT" && !window.config.isChina)
          {
            window.config.hasDispatchedAgentEWT = false;
            window.config.isTextArea = true;
          }
          context.setSessionId(action.payload.activity.conversation.id)
          context.setLiveAgentName(action.payload.activity.value.agentname);
          context.setShowSendBox(true);
          context.setHideStickyMenu(true);
          context.setDisableSendBox(false);
          setShowTimerBox(false);
          context.setLiveAgent(true);
          showModal(false);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "languageUserSelected")
        ) {
          context.setLiveAgentDropdownLanguagePreferred(action.payload.activity.value.liveAgentPreferredLanguage);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentJoinedTransfer")
        ) {
          context.setTranscriptTranslationRequired(action.payload.activity.value.transcriptTranslationRequired);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "SendTriggerSurvey"
        ) {
          context.setShowSurvey(true);
          surveyPageShow.current = true;
          dispatch({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "GetSurveyLink"
            }
          });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "hideStickyMenu"
        ) {
          context.setHideStickyMenu(true);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "displayStickyMenu"
        ) {
          context.setHideStickyMenu(false);
        }

        if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "GetGreeting"
        ) {
          const currentTime = new Date();
          let greetingMessage = "";

          if (currentTime.getHours() < 12) {
            greetingMessage = "Good Morning";
          } else if (currentTime.getHours() < 17) {
            greetingMessage = "Good Afternoon";
          } else {
            greetingMessage = "Good Evening";
          }

          dispatch({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "SendGreeting",
              value: greetingMessage
            }
          });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentqueuecount"
        ) {
          if (!window.config.isNewUI) {
            context.setShowSendBox(false);
          }
          setShowTimerBox(true);
          context.setUsersCount(action.payload.activity.value);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "SatmetrixSurveyLink"
        ) {
          if (satmatrixSurvey)
          setSatmatrixSurveyIFrame(true);
          setSurveyLink(action.payload.activity.value);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          isRejectedActivity
        ) {
          isRejectedActivity = false;
          if (document.getElementsByClassName("sendRetry").length != 0) {
            Array.prototype.forEach.call(
              document.getElementsByClassName("sendRetry"),
              function (element) {
                element.style.visibility = "hidden";
              }
            );
            Array.prototype.forEach.call(
              document.getElementsByClassName("sendRetry"),
              function (element) {
                element.style.display = "none";
              }
            );
          }
        }

        if (
          action.type === "DIRECT_LINE/POST_ACTIVITY_REJECTED" &&
          action.error
        ) {
          if (action.payload.message.indexOf("cancelled timeout") !== -1) {
            showErrorPage({
              isErrorOccured: true,
              message: {
                text: "Network Error",
                subText: "The network connection is lost",
                link: {
                  text: "Please Contact Customer Support",
                  src: window.config.supportUrl,
                  target: "_blank"
                }
              }
            });
            setSpinner(false);
          } else {
            isRejectedActivity = true;
            if (document.getElementsByClassName("sendRetry").length != 0) {
              document.getElementsByClassName("sendRetry")[
                document.getElementsByClassName("sendRetry").length - 1
              ].style.visibility = "visible";
              document.getElementsByClassName("sendRetry")[
                document.getElementsByClassName("sendRetry").length - 1
              ].style.display = "block";
            }
          }
        }

        if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "accountChangedPopup"
        ) {
          showModal(true);
          context.setIsAccountChanged(true)
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
        }
        try {
          let result = next(action);
          return result;
        } catch (err) {
        }
      });
    window._dcaStore = newStore;
    setStore(
      newStore,
      [
        showSpinner,
        accessToken,
        handleSpinnerChange,
        setSpinner,
        handleModalChange,
        setSurveyLink,
        setSatmatrixSurveyIFrame
      ]
    );
  }

  return (
    isDisplay && (
        <React.Fragment>
          <div className="main" id="main">
            <Header
              isMaximised={isMaximised}
              ref={headerRef}
              store={store}
              directLine={directLine}
              handleRefreshModalPopup={handleRefreshModalPopup}
              handleCloseModalPopup={handleCloseModalPopup}
              handleMaximizeChange={handleMaximizeChange}
              handleModalChange={handleModalChange}
              handleSurveyCardChange={handleSurveyCardChange}
              isOpenModal={isOpenModal}
              isLiveAgent={isLiveAgent}
              userLanguage={userLanguage}
              headerIconsDisplay={headerIconsDisplay}
              surveyLink={surveyLink}
              isSurveyOpen={isSurveyOpen}
            />
            {accessToken && !errorOccured.isErrorOccured ? (
             <MainWebChat
                showSpinner={showSpinner}
                isMaximised={isMaximised}
                isSurveyOpen={isSurveyOpen}
                userLanguage={userLanguage}
                handleMaximizeChange={handleMaximizeChange}
                handleCloseModalPopup={handleCloseModalPopup}
                handleSurveyCardChange={handleSurveyCardChange}
                directLine={directLine}
                store={store}
                isLiveAgent={isLiveAgent}
                handleModalChange={handleModalChange}
                styleSet={styleSet({})}
                appInsights={appInsights}
                showTimerBox={showTimerBox}
                setShowTimerBox={setShowTimerBox}
                handleSpinnerChange={handleSpinnerChange}
                showSurvey={showSurvey}
                setHeaderIconsDisplay={setHeaderIconsDisplay}
                surveyLink={surveyLink}
                setSatmatrixSurvey={setSatmatrixSurvey}
                setSatmatrixSurveyIFrame={setSatmatrixSurveyIFrame}
                satmatrixSurveyIFrame={satmatrixSurveyIFrame}
                isAgentInitiated={isAgentInitiated}
                setLiveAgent={setLiveAgent}
                setDirectLineTokenCall={setDirectLineTokenCall}
                headerRef={headerRef}
              />
            ) : (
               !errorOccured.isErrorOccured && (
                <ErrorHandler
                  isMaximised={isMaximised}
                  message={{
                    text: "Access Denied",
                    subText: "You are not authorized to use this application.",
                    link: {
                      text: "Please Contact Customer Support",
                      src: window.config.supportUrl,
                      target: "_blank"
                    }
                  }}
                />
              )
            )}
            {errorOccured.isErrorOccured ? (
              <ErrorHandler
                isMaximised={isMaximised}
                message={errorOccured.message}
              />
            ) : (
              ""
            )}
            <Footer isMaximised={isMaximised} />
          </div>
        </React.Fragment>
    )
  );
};